import React, { useEffect, useState } from "react";
import SideBar from "./Questionnaire/Sidebar";
import { extractDesignation } from "./Utils";

export const Questionnaire = ({
  platform = "FM",
  questionnaireId = "",
  middleware = "",
  folderId = "",
  filterData = {},
  showSideBar=true,
  setShowSideBar = () => {},
  editQuestionnaire = () => {},
  score_Data=null,
  imageUrl="",
  name="",
  currentEmployment=null,
  isExpired=false
}) => {
  return (
    <SideBar
      isExpired={isExpired}
      platform={platform}
      questionnaireId={questionnaireId}
      editQuestionnaire={editQuestionnaire}
      middleware={middleware}
      folderId={folderId}
      filterData={filterData}
      showSideBar={showSideBar}
      setShowSideBar={setShowSideBar}
      score_Data={score_Data}
      imageUrl={imageUrl}
      name={name}
      designation={extractDesignation(currentEmployment)}
    />
  );
};
